import React, {memo} from "react";
import PropTypes from "prop-types";
import {Grid, useTheme} from "@mui/material";
import "suneditor/dist/css/suneditor.min.css";
import SunEditor from "suneditor-react";
import DOMPurify from "dompurify";
import {EDITOR_DOMPURIFY_CONFIG} from "./EditorSettings";
import {useEditorStyles} from "./editorStyles";

const StaticEditor = ({backgroundColor, defaultStyle, defaultValue, name}) => {
  const theme = useTheme();
  const {classes, cx} = useEditorStyles({
    backgroundColor,
    disabled: true,
    inline: true,
  });

  const purifiedDefaultValue = DOMPurify.sanitize(defaultValue, EDITOR_DOMPURIFY_CONFIG);

  const getSunEditorInstance = (sunEditor) => {
    if (sunEditor.core && sunEditor.core._resourcesStateChange) {
      const originalMethod = sunEditor.core._resourcesStateChange;
      sunEditor.core._resourcesStateChange = function() {
        try {
          // eslint-disable-next-line prefer-rest-params
          return originalMethod.apply(this, arguments);
        } catch (error) {
          if (`${error?.message}`.includes("this._iframeAutoHeight is not a function")) {
            return null;
          }
          console.error(error);
        }
      };
    }
    if (sunEditor.core) {
      sunEditor.core.selectComponent = function() {
        return false;
      };
    }
  };

  return (
    <Grid container data-tour={`sun-editor${name && `-${name}`}`}>
      <Grid item xs={12}>
        <span
          className={cx(classes.editor, classes.staticEditor)}
          id="static-editor-wrapper"
          data-testid="static-editor-wrapper"
        >
          <SunEditor
            setContents={purifiedDefaultValue}
            getSunEditorInstance={getSunEditorInstance}
            disable
            disableToolbar
            hideToolbar
            name={name || "editor"}
            height="100%"
            setDefaultStyle={
              defaultStyle ?? `font-family: ${theme.typography.fontFamily};font-size: 16px;`
            }
            setOptions={{mode: "inline", buttonList: [], showPathLabel: false}}
          />
        </span>
      </Grid>
    </Grid>
  );
};

StaticEditor.propTypes = {
  backgroundColor: PropTypes.string,
  defaultStyle: PropTypes.string,
  defaultValue: PropTypes.string,
  name: PropTypes.string,
};

export default memo(StaticEditor);
